import React from 'react';
import { Tag } from 'primereact/tag';
import { Button } from 'primereact/button';

const GeneralInfo = ({
	productionName,
	machineId,
	plcVersion,
	posVersion,
	availableForCustomer,
	mobileActive,
	ipOpenvpn,
	locationFullAddress,
	locationId,
	onCopyToClipboard,
}) => {
	const handleCopyId = () => {
		if (onCopyToClipboard) {
			onCopyToClipboard(machineId);
		}
	};

	const handleCopyLocationId = () => {
		if (onCopyToClipboard) {
			onCopyToClipboard(locationId);
		}
	};

	return (
		<div className="surface-0 border-1 surface-border border-round-md overflow-hidden">
			<div className="surface-50 px-3 py-2 border-bottom-1 surface-border">
				<h3 className="text-xs font-semibold text-500 m-0 uppercase tracking-wider">
					<i className="pi pi-info-circle mr-2"></i>
					General Information
				</h3>
			</div>

			<div className="p-3">
				<div className="grid">
					<div className="col-12">
						<div className="flex flex-column gap-1 mb-3 ">
							<span className="text-xs text-500 font-medium uppercase tracking-wider">Production Name</span>
							<span className="text-sm text-900 font-medium">{productionName || 'Not set'}</span>
						</div>
					</div>

					{plcVersion && (
						<div className="col-12 md:col-6 border-bottom-1 border-top-1 surface-border">
							<div className="flex flex-column gap-1 mb-3">
								<span className="text-xs text-500 font-medium uppercase tracking-wider">PLC Version</span>
								<span className="text-sm text-900 font-mono">{plcVersion}</span>
							</div>
						</div>
					)}

					{posVersion && (
						<div className="col-12 md:col-6 border-bottom-1 border-top-1 surface-border">
							<div className="flex flex-column gap-1 mb-3">
								<span className="text-xs text-500 font-medium uppercase tracking-wider">POS Version</span>
								<span className="text-sm text-900 font-mono">{posVersion}</span>
							</div>
						</div>
					)}

					<div className="col-12 md:col-6">
						<div className="flex flex-column gap-1 mb-3">
							<span className="text-xs text-500 font-medium uppercase tracking-wider">Available for Customer</span>
							<Tag
								className="text-xs font-medium w-fit"
								severity={availableForCustomer ? 'success' : 'danger'}
								value={availableForCustomer ? 'Available' : 'Unavailable'}
							/>
						</div>
					</div>

					<div className="col-12 md:col-6">
						<div className="flex flex-column gap-1 mb-3">
							<span className="text-xs text-500 font-medium uppercase tracking-wider">Mobile Active</span>
							<Tag
								className="text-xs font-medium w-fit"
								severity={mobileActive ? 'success' : 'warning'}
								value={mobileActive ? 'Active' : 'Inactive'}
							/>
						</div>
					</div>

					{ipOpenvpn && (
						<div className="col-12">
							<div className="flex flex-column gap-1 mb-3">
								<span className="text-xs text-500 font-medium uppercase tracking-wider">IP Address</span>
								<a
									href={`http://${ipOpenvpn}`}
									target="_blank"
									rel="noopener noreferrer"
									className="text-sm text-primary-500 no-underline hover:text-primary-600 font-mono w-fit"
								>
									{ipOpenvpn} <i className="pi pi-external-link ml-1"></i>
								</a>
							</div>
						</div>
					)}

					<div className="col-12 bg-bluegray-50 border-round-sm mb-1">
						<div className="flex flex-column gap-1 mb-3">
							<span className="text-xs text-500 font-medium uppercase tracking-wider">Machine ID</span>
							<div className="flex align-items-center gap-2">
								<span className="text-sm text-900 font-mono">{machineId}</span>
								<Button
									icon="pi pi-copy"
									className="p-button-text p-button-sm"
									onClick={handleCopyId}
									tooltip="Copy Machine ID"
									tooltipOptions={{ position: 'top' }}
									style={{ color: 'var(--primary-color)', padding: '0.25rem' }}
								/>
							</div>
						</div>
					</div>

					<div className="col-12 bg-bluegray-50 border-round-sm">
						<div className="flex flex-column gap-1">
							<span className="text-xs text-500 font-medium uppercase tracking-wider">Location</span>
							<span className="text-sm text-900">{locationFullAddress || 'No location set'}</span>
							{locationId && (
								<div className="flex align-items-center gap-2">
									<span className="text-xs text-700 font-mono">ID: {locationId}</span>
									<Button
										icon="pi pi-copy"
										aria-label="Copy Location ID"
										className="p-button-text p-button-sm"
										onClick={handleCopyLocationId}
										tooltip="Copy Location ID"
										tooltipOptions={{ position: 'top' }}
										style={{ color: 'var(--primary-color)', padding: '0.25rem' }}
									/>
								</div>
							)}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default GeneralInfo;
